
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Field } from '@/mixins'

@Component({
  components: {
  }
})

export default class FieldNumber extends Mixins(Field) {
  // v-model.number used on component will bind to this value
  @Prop({ required: true })
  private readonly value!: number;

  @Prop({ default: '' })
  private readonly min!: string

  @Prop({ default: '' })
  private readonly max!: string

  @Prop({ default: '' })
  private readonly step!: string
}

